//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mdiDotsVertical } from '@mdi/js'
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    VueApexCharts,
  },
  setup() {
    const chartOptions = {
      chart: {
        sparkline: {
          enabled: false,
        },
      },
      plotOptions: {
        radialBar: {
          hollow: {
            size: '30%',
          },
          track: {
            background: '#ebe9f1',
          },
          dataLabels: {
            show: false,
            name: {
              show: false,
            },
          },
        },
      },

      grid: {
        padding: {
          bottom: -15,
        },
      },
    }

    const teamMembers = [
      {
        avatar: require('@/assets/images/avatars/1.png'),
        title: 'Dean Hogan',
        subtitle: 'iOS Developer',
        chipText: 'Zipcar',
        chipColor: 'primary',
        task: '87/135',
        series: [65],
        chartColor: '#9155fd',
      },
      {
        avatar: require('@/assets/images/avatars/8.png'),
        title: 'Hilda Rice',
        subtitle: 'iOS Developer',
        chipText: 'Brandi',
        chipColor: 'success',
        task: '340/420',
        series: [75],
        chartColor: '#56ca00',
      },
      {
        avatar: require('@/assets/images/avatars/5.png'),
        title: 'Andrew Obrien',
        subtitle: 'iOS Developer',
        chipText: 'Payers',
        chipColor: 'warning',
        task: '50/82',
        series: [55],
        chartColor: '#ffb400',
      },
      {
        avatar: require('@/assets/images/avatars/2.png'),
        title: 'Eleanor Price',
        subtitle: 'iOS Developer',
        chipText: 'Bitbank',
        chipColor: 'error',
        task: '98/260',
        series: [60],
        chartColor: '#ff4c51',
      },
      {
        avatar: require('@/assets/images/avatars/3.png'),
        title: 'Carl Oliver',
        subtitle: 'iOS Developer',
        chipText: 'Aviato',
        chipColor: 'secondary',
        task: '12/25',
        series: [60],
        chartColor: '#656971',
      },
    ]

    const getChartConfig = value => {
      const options = JSON.parse(JSON.stringify(chartOptions))
      options.colors = [value]

      return options
    }

    return {
      teamMembers,
      chartOptions,
      getChartConfig,
      icons: {
        mdiDotsVertical,
      },
    }
  },
}
